import { StartExercise, UpdateObjective } from "Phaser/EventBus";
import { Exercise, Lecture, PianoScene, Tutorial, Section, Event, NoTimeExercise, StaffExercise } from "Utils/TutorialConfigHelper";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level11.json";

const Level11 = Tutorial(11,
  '2:17',
  [
    Section([
      Lecture('F in the Bass Clef', '0:0'),
      Lecture('F on the Keyboard', '0:12'),
      Exercise(
        'Find F', '0:24',
        PianoScene({
          objectives: [{
            text: 'Play F on your keyboard.',
            target: 'F3',
          }]
        }),
        [
        ]
      )
    ]),
    Section([
      Lecture('Playing with the 5th Finger', '0:30'),
      Exercise('Playing F', '0:34', NoTimeExercise(
        {
          padding_x: 700,
          objectives: [
            {
            }
          ]
        }),
        [
        ]
      ),
      Lecture('5th Finger Technique', '0:41'),
      Exercise('Alternating Fingers', '1:13',
        NoTimeExercise({
          centre_align_horizontal: true,
          objectives: [
            {
            },
            {
            },
            {
            }
          ]
        }),
        [
        ]
      ),
      Exercise('Playing in Time', '1:29',
        StaffExercise({
          objectives: [
            {
            },
            {
            },
          ]
        }),
        [
        ]
      )
    ]),
    Section([
      Lecture('Using Both Hands', '1:46'),
      Exercise('Alternating Hands', '1:52',
        StaffExercise({
          objectives: [
            {
            },
          ]
        }),
        [
        ]
      ),
      Exercise('Hands Together', '1:58',
        StaffExercise({
          objectives: [
            {
            },
            {
            },
          ]
        }),
        [
        ]
      )
    ])
  ]
);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level11);
